// eslint-disable-next-line no-unused-vars
import * as React from "react";
import SocialBarContainer from "app/pages/.shared/social/SocialBarContainer";
import "./SocialBarPopover.scss";
import PropTypes from "prop-types";
import FloatingButton from "app/pages/.shared/Popover/FloatingButton";

const SocialBarPopover = ({ buttonLabel, position, urlToShare }) => {
	return (
		<div className="socialbar-popover" data-testid="socialbar-popover">
			<FloatingButton
				popoverClassName={"socialbar-popover__popover"}
				referenceComponent={buttonLabel}
				position={position}
				floatingContent={<SocialBarContainer urlToShare={urlToShare} />}
				floatingOffsetDesk={[0, -8]}
				floatingOffsetMobile={[0, 6]}
			/>
		</div>
	);
};

SocialBarPopover.propTypes = {
	position: PropTypes.string,
	buttonLabel: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
	urlToShare: PropTypes.string.isRequired,
};

export default SocialBarPopover;
